import {TextareaAutosize, Typography} from "@mui/material";
import * as React from "react";
import {ComponentConfig} from "../../Config/ComponentConfig";
import {Colors} from "../../Constants/Colors";
import PrimaryButton from "../Common/PrimaryButton.tsx";
import Completed from "../../components/Icons/Completed";

interface UpcomingAppointmentInputInstructionsProps {
    onSubmit: (instructions: string) => void;
    instructionStatus?: string;
}

export const UpcomingAppointmentInputInstructions = ({
                                                         onSubmit,
                                                         instructionStatus
                                                     }: UpcomingAppointmentInputInstructionsProps) => {
    const [instructions, setInstructions] = React.useState<string>("");
    return (
        <>
            {instructionStatus === "idle" ? (
                <>
                    <Typography className="subtitle-medium" variant={"subtitleMedium"}>
                        Instructions for doctor
                    </Typography>
                    <TextareaAutosize
                        minRows={2}
                        value={instructions}
                        onChange={(e) => setInstructions(e.target.value)}
                        placeholder="Add instructions..."
                        style={{
                            width: "100%",
                            padding: "12px",
                            borderRadius: ComponentConfig.ButtonBorderRadius,
                            borderColor: Colors.grey,
                            fontFamily: "inherit",
                            outline: "none",
                        }}
                    />
                    <PrimaryButton
                        onTap={() =>
                            onSubmit(instructions)}
                        textClassName="subtitle-medium"
                        fullWidth
                        text="Add Instructions"
                        sx={{
                            background: ComponentConfig.primaryButtonGradient,
                            color: "white",
                            fontWeight: "bold",
                            marginTop: 2,
                        }}
                    />
                </>
            ) : (
                <div
                    style={{
                        width: "calc(100%)",
                        marginTop: "16px",
                        padding: "24px",
                        background: "#179D820F",
                        fontSize: "12px",
                        fontWeight: "500",
                        borderRadius: ComponentConfig.ButtonBorderRadius,
                    }}
                >
                    <Completed/>
                    <p style={{marginBlock: "12px"}}>Instructions noted!</p>
                    <p style={{margin: "0"}}>
                        Please relax, doctor will be at your location shortly
                    </p>
                </div>
            )}
        </>
    );
};
